import { render, staticRenderFns } from "./HowGetReportInfo.vue?vue&type=template&id=1c2a2d74&"
import script from "./HowGetReportInfo.vue?vue&type=script&lang=js&"
export * from "./HowGetReportInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports